import * as React from "react";
const SvgTpmChip = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M2.342 1.871v15.27l4.83 2.54L12 22.226l4.828-2.543 4.83-2.541V1.87H12ZM3.85 3.38h16.3v12.86l-4.076 2.144L12 20.525l-4.074-2.142-4.076-2.145v-6.43Z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } }),
    React.createElement("path", { d: "M9.928 5v1.742H7.742v2.186H6v.871h1.742V12.2H6v.871h1.742v2.186h2.186V17h.871v-1.742H13.2V17h.871v-1.742h2.186v-2.186H18v-.871h-1.742V9.8H18v-.871h-1.742V6.742h-2.186V5h-.871v1.742H10.8V5h-.436ZM8.619 7.62H15.38v6.76H8.62V11Z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgTpmChip;
